export default __webpack_public_path__ + "static/media/Opera.ff8fd0d4.svg";